import classNames from "classnames";
import ConditionalToolTip from "components/design/conditionalToolTip";
import { EyeIcon } from "components/icons/EyeIcon";
import { useAppDispatch } from "hooks/useAppDispatch";
import React, { useMemo } from "react";
import { openMessageInfoSlider } from "store/slices/channelInfoSlider";
import { useChannelStateContext } from "stream-chat-react";
import { getMessageReadByUser, ReadData } from "utils/getMessageReadByUser";

export const LastMessageSeenBy = ({
  messageId,
  messageCreatedAt,
  isSystemMessage,
}: {
  messageId: string;
  messageCreatedAt?: string | Date;
  isSystemMessage?: boolean;
}) => {
  const { read } = useChannelStateContext();
  const dispatch = useAppDispatch();
  const messageReadByUser = useMemo(
    () =>
      getMessageReadByUser({
        read: read as unknown as ReadData,
        messageCreatedAt,
      }),
    [read, messageCreatedAt]
  );

  const openMessageInfo = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    dispatch(openMessageInfoSlider(messageId));
  };

  if (messageReadByUser.length === 0) {
    return null;
  }

  return (
    <div className="t-w-fit">
      <ConditionalToolTip
        condition={
          messageReadByUser.length > 3 && (
            <div>
              {messageReadByUser.slice(3).map(({ user }) => (
                <div key={user.name}>{user.name}</div>
              ))}
            </div>
          )
        }
        side="right"
      >
        <div
          className={classNames(
            "t-flex t-items-center t-gap-1 t-text-text-30 t-mt-2",
            {
              "t-ml-10": !isSystemMessage,
            }
          )}
        >
          <EyeIcon />
          <button
            className="all:unset hover:t-underline t-text-body-sm t-cursor-pointer"
            onClick={openMessageInfo}
          >
            Seen by{" "}
            {messageReadByUser
              .slice(0, 3)
              .map(({ user }) => user.name)
              .join(", ")}{" "}
            {messageReadByUser.length > 3 && "+"}
          </button>
        </div>
      </ConditionalToolTip>
    </div>
  );
};
